module.exports = __webpack_public_path__ + "media/flags/pw-177a477f.svg";